import api from "../../api";

const adapter = {
  formToRequestBody(input = []){
    let result = []

    if(input && input.length > 0){
      for (let index = 0; index < input.length; index++) {
        const image = input[index];
        result.push({
          deskripsiGambar: [image.blob, image.blob],
          typeVisibility: 1
        })
      }
    }

    return result
  },
  responseBodyToRender(input = []){
    let result = []

    if(input && input.length > 0){
      for (let index = 0; index < input.length; index++) {
        const image = input[index];
        result.push({
          url: api.base_image+image.imgGambar
        })
      }
    }

    return result
  },
  responseBodyToForm(input = []){
    const result = []

    if(input && input.length > 0){
      for (let index = 0; index < input.length; index++) {
        const galleryItem = input[index];
        result.push({
          pkId: galleryItem.pkGalleryId,
          url: api.base_image+galleryItem.imgGambar
        })
      }
    }

    return result
  }
}

export default adapter
